import { render, staticRenderFns } from "./ValidacionTareas.vue?vue&type=template&id=2a08c333&scoped=true"
import script from "./ValidacionTareas.vue?vue&type=script&lang=js"
export * from "./ValidacionTareas.vue?vue&type=script&lang=js"
import style0 from "./ValidacionTareas.vue?vue&type=style&index=0&id=2a08c333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08c333",
  null
  
)

export default component.exports